import "./ProjectHeroBrainFlix.scss";

function ProjectHeroBrainFlix() {
  return (
    <>
      <section class="project-cs-hero">
        <div class="project-cs-hero__content">
          <h1 class="heading-primary">BrainFlix</h1>
          <div class="project-cs-hero__info">
            <p class="text-primary text-primary--project">A YouTube clone.</p>
          </div>
          <div class="project-cs-hero__cta">
            <a
              href="/project"
              class="btn btn--bg"
              target="_blank"
              rel="noreferrer"
            >
              Live Link
            </a>
          </div>
        </div>
      </section>
    </>
  );
}

export default ProjectHeroBrainFlix;
